import request from '../utils/fetch';

// 预设属性列表
export const getPrePropList = async (): Promise<any> => {
  return request('/model/v1/conflict/preProp/list', {
    // tokenFree: true,
    method: 'GET',
    params: {
      t: Date.now(),
    },
  });
};

// 预设属性详情
export const getPrePropInfo = async (prePropId: any): Promise<any> => {
  return request(`/model/v1/conflict/preProp/info/${prePropId}`, {
    // tokenFree: true,
    method: 'GET',
    params: {
      t: Date.now(),
    },
  });
};

// 添加预设属性
export const addPreProp = async (data: addPrePropParams): Promise<any> => {
  return request('/model/v1/conflict/preProp/add', {
    // tokenFree: true,
    method: 'POST',
    data,
  });
};

// 编辑预设对象
export const updatePreProp = async (data: addPrePropParams): Promise<any> => {
  return request('/model/v1/conflict/preProp/update', {
    // tokenFree: true,
    method: 'POST',
    data,
  });
};

// 预设属性复制
export const copyPreProp = async (prePropId: string): Promise<any> => {
  return request(`/model/v1/conflict/preProp/copy/${prePropId}`, {
    // tokenFree: true,
    method: 'POST',
  });
};

// 预设属性删除
export const deletePreProp = async (prePropId: string): Promise<any> => {
  return request(`/model/v1/conflict/preProp/delete/${prePropId}`, {
    // tokenFree: true,
    method: 'DELETE',
  });
};

// 对象发布
export const publishPreProp = async (data: {
  prePropId: string;
  published: boolean;
}): Promise<any> => {
  return request(`/model/v1/conflict/preProp/published/set`, {
    // tokenFree: true,
    method: 'POST',
    data,
  });
};
